// GAVION X5: « Meilleures heures d'appel » (Rapports) et l'indice du composeur.
export const callHoursFr = {
  title: "Meilleures heures d'appel",
  description:
    "Taux de réponse et de démos par jour et heure, à l'heure locale de la compagnie",
  local_time:
    "Heure locale de la compagnie (America/Toronto si le fuseau est inconnu). Du %{from} au %{to}.",
  filters: {
    label: "Filtres des heures d'appel",
    period: "Période",
    days: {
      30: "30 derniers jours",
      90: "90 derniers jours",
      365: "12 derniers mois",
    },
    trade: "Métier",
    all_trades: "Tous les métiers",
    region: "Région",
    rep: "Représentant",
    all_reps: "Toute l'équipe",
    scope: "Appels",
    scope_me: "Mes appels",
    scope_team: "Toute l'équipe (agrégé)",
    metric: "Mesure",
    metrics: {
      connect: "Taux de réponse",
      demo: "Taux de démos",
    },
  },
  heatmap: {
    title: "%{metric} par jour et heure",
    cell: "%{day} %{hour} h : %{smart_count} appel, %{rate} |||| %{day} %{hour} h : %{smart_count} appels, %{rate}",
    cell_thin:
      "%{day} %{hour} h : %{smart_count} appel — pas assez de données |||| %{day} %{hour} h : %{smart_count} appels — pas assez de données",
    cell_empty: "%{day} %{hour} h : aucun appel",
    legend_low: "Bas",
    legend_high: "Haut (%{rate})",
    legend_thin: "Pas assez de données (moins de %{min} appels)",
    cell_note: "Chaque case indique le nombre d'appels.",
  },
  table: {
    day: "Jour",
    hour: "Heure",
    dials: "Appels",
    connect: "Réponse",
    demo: "Démos",
  },
  recommendations: {
    title: "Meilleurs créneaux",
    for: "%{trade} : %{window}, %{rate} de réponse",
    window: "%{day} %{from} h–%{to} h",
    detail:
      "%{smart_count} appel, %{demo} de démos |||| %{smart_count} appels, %{demo} de démos",
    none: "Pas assez d'appels pour recommander un créneau (au moins %{min} appels par créneau).",
    sample_note: "Créneaux d'une heure avec au moins %{min} appels.",
  },
  hint: {
    label: "Meilleur moment pour ce métier",
    text: "Meilleur moment : %{window} (%{rate} de réponse)",
  },
};
